import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Container } from "@mui/material";
import Header from "./components/Header";
import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import NotFound from "./pages/NotFound";
import { auth } from "./api/fbConfig";


import Loader from "./components/Loader";



function App() {
  const [userLoading, setUserLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    setUserLoading(true);
  
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          setCurrentUser(user);
          console.log(`setCurrentUser(${user.uid})`);
  
          
        } catch (error) {
          console.error("Error managing user data:", error);
        }
      } else {
        setCurrentUser(null);
      }
      setUserLoading(false);
    });
  }, []);


  if (userLoading) {
    return (<Loader/>);
  }

  if (!currentUser) {
    return <Login />;
  }
  console.log("here")

  return (
    <Router>
      {/*<Header>*/}
        <Container>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/logout" element={<Logout />} />
     
            {/* 404 Page */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Container>
      {/*</Header>*/}
    </Router>
  );
}

export default App;
